var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2305_20275)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2305_20275)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2305_20275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.355469 0.375V25.7825H6.70735V32.1344H13.0592V25.7825H25.763V0.375H0.355469ZM25.763 25.7825V32.1344H32.1148V38.4863H19.4111V44.8381H0.355469V70.2457H25.763V44.8381H44.8186V38.4863H38.4668V32.1344H51.1706V25.7825H57.5224V32.1344H63.8743V25.7825H70.2262V0.375H44.8186V25.7825H25.763ZM63.8743 32.1344V38.4863H70.2262V32.1344H63.8743ZM63.8743 38.4863H57.5224V44.8381H63.8743V38.4863ZM63.8743 44.8381V51.1901H70.2262V44.8381H63.8743ZM63.8743 51.1901H57.5224V44.8381H51.1706V51.1901H35.2908V70.2457H41.6426V57.5419H54.3464V63.8939H60.6984V57.5419H63.8743V51.1901ZM54.3464 63.8939H47.9946V70.2457H54.3464V63.8939ZM57.5224 38.4863V32.1344H51.1706V38.4863H57.5224ZM19.4111 38.4863V32.1344H13.0592V38.4863H19.4111ZM6.70735 32.1344H0.355469V38.4863H6.70735V32.1344ZM32.1148 0.375V13.0788H28.939V19.4306H32.1148V22.6066H38.4668V13.0788H41.6426V6.72689H38.4668V0.375H32.1148ZM6.70735 6.72689H19.4111V19.4306H6.70735V6.72689ZM51.1706 6.72689H63.8743V19.4306H51.1706V6.72689ZM9.88329 9.90282V16.2547H16.2352V9.90282H9.88329ZM54.3464 9.90282V16.2547H60.6984V9.90282H54.3464ZM6.70735 51.1901H19.4111V63.8939H6.70735V51.1901ZM9.88329 54.3659V60.7179H16.2352V54.3659H9.88329ZM63.8743 63.8939V70.2457H70.2262V63.8939H63.8743Z",
    fill: "url(#paint0_linear_2305_20275)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2305_20275",
    x1: 14.6893,
    y1: 0.259906,
    x2: 75.7365,
    y2: 5.40571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2305_20275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.8707,
    height: 69.8707,
    fill: "white",
    transform: "translate(0.355469 0.375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2305_20275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.8707,
    height: 69.8707,
    fill: "white",
    transform: "translate(0.355469 0.375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2305_20275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.8707,
    height: 69.8707,
    fill: "white",
    transform: "translate(0.355469 0.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.033410aab18dcc6fd44b68987f46d586.svg";
export { ForwardRef as ReactComponent };